var render = function render(){var _vm=this,_c=_vm._self._c;return _c('bsc-part',{attrs:{"page-type":"elevator"}})
}
var staticRenderFns = []

export { render, staticRenderFns }